import React from "react";
import { useModal } from "../contexts/ModalContext";

const Modal = () => {
	const { title, content, action, isModalOpen, closeModal } = useModal();

	if (!isModalOpen) return null;

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div className="flex flex-col p-4 gap-2 w-[400px] max-h-[90%] bg-white rounded-lg shadow-lg max-[384px]:w-[320px] max-[512px]:w-[360px] sm:p-5 sm:w-[440px] md:p-6 md:w-[480px]">
				<div className="flex mb-1 h-8 justify-between items-center border-b border-b-violet-300">
					<h2 className="text-lg font-medium text-violet-950">{title}</h2>
					<button
						onClick={() => closeModal()}
						className="flex w-6 h-6 justify-center items-center self-center rounded bg-red-700 text-white border hover:bg-red-600 transition-all duration-300">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="size-6">
							<path
								fillRule="evenodd"
								d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
								clipRule="evenodd"
							/>
						</svg>
					</button>
				</div>

				<div className="overflow-auto">{content}</div>

				<div className="mt-1 border-b border-b-violet-300" />

				<div className="flex flex-row gap-2 rounded">
					<button
						onClick={() => closeModal()}
						className="flex-1 px-3 py-1 bg-violet-950 text-white rounded hover:bg-violet-900">
						OK
					</button>

					{action && (
						<div className="mt-3 flex justify-end">
							<button
								onClick={() => action?.()}
								className="flex-1 px-3 py-1 bg-violet-950 text-white rounded hover:bg-violet-900">
								OK
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Modal;
